import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Combine Tailwind classes with conflict resolution. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

// Base58 alphabet Solana uses (Bitcoin alphabet minus 0, O, I, l).
const BASE58_RE = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/

/** Client-side sanity check for a Solana pubkey: base58 alphabet,
 *  32-44 chars. Not a full on-curve check (that needs the actual key
 *  bytes) — just enough to catch typos/pasted garbage before the
 *  request round-trips to the server, which does the real validation. */
export function isBase58Pubkey(s: string): boolean {
  return BASE58_RE.test(s.trim())
}
